import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
  title: ReactNode
  description: ReactNode
  className?: string
}

export const StepCardContent = ({ children, title, description, className }: Props) => {
  return (
    <div className="flex w-full flex-1 flex-col gap-6">
      <div className="mx-auto flex w-80 flex-col gap-4 text-center lg:w-full">
        <h1 className="text-3xl font-bold text-gray-12">{title}</h1>
        <p className="text-base lg:font-medium">{description}</p>
      </div>
      <div className={className}>{children}</div>
    </div>
  )
}
